import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import lottie from "assets/lottie/Loading.lottie";
export const WaitMessaggeAnimation = () => {
  return (
    <div className="width-px-28 height-px-28">
      <DotLottieReact src={lottie} loop autoplay />
    </div>
  );
};
